import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DrawerComp from "./Drawer";
import Drawer from "@mui/material/Drawer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import memoji from "./Memoji.png";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import RouteIcon from "@mui/icons-material/Route";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import List from "@mui/material/List";

const Header = ({ hasBorder = false }) => {
  const dashboardList1 = [
    {
      title: "Track Order",
      icon: <RouteIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Activity",
      icon: <BoltOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Saved Address",
      icon: <GroupsOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Payments",
      icon: <CreditCardOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Favourite",
      icon: <FavoriteBorderOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Promotions",
      icon: <LocalOfferOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Gift Card",
      icon: <WorkspacePremiumOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
  ];

  let navigate = useNavigate();
  const [state, setState] = React.useState({
    right: false,
  });
  //const [navSize, setnavSize] = useState("10rem");
  const [navColor, setnavColor] = useState("transparent");
  const [userFullName, setUserFullName] = useState(null);
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#F9FFFF") : setnavColor("transparent");
    // window.scrollY > 10 ? setnavSize("5rem") : setnavSize("5rem");
  };
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"))
    console.log("Data hai", userData)
    if (userData !== null && userData !== undefined) {
      setUserFullName(userData?.profile?.fullName);
      window.addEventListener("scroll", listenScrollEvent);
      return () => {
        window.removeEventListener("scroll", listenScrollEvent);
      };
    };
  }, []);

  const [value, setValue] = useState();
  const [getValLocal, setValLocal] = useState(false);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleLogout = () => {
    localStorage.removeItem("navBtn");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setTimeout(() => {
      setValLocal(false);
      toggleDrawer("right", false);
      window.location.reload(true)
    }, 1000);
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: 377, md: 377, sm: 377, xs: "100%" },
        padding: "32px 16px",
      }}
      role="presentation"
    // onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", flexDirection: "row", pb: "24px" }}>
        <Box sx={{ width: "56px", height: "56px" }}>
          <img
            src="./images/Drop your Memoji here.svg"
            alt=""
            width="100%"
            height="auto"
          />
        </Box>
        <Box sx={{ pl: "16px" }}>
          <Typography
            sx={{
              fontSize: {
                xl: "",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            {userFullName}
          </Typography>
          <Link to="/dashboard" component="button">
            <Typography
              color="primary"
              sx={{
                fontSize: {
                  xl: "",
                  lg: "14px",
                  md: "14px",
                  sm: "14px",
                  xs: "14px",
                },
              }}
            >
              View Profile
            </Typography>
          </Link>
        </Box>
      </Box>

      <List sx={{ color: "#1A1824" }}>
        <ListItemText
          primary={"My Account"}
          sx={{ color: "#9EA3AE", pb: "20px" }}
        ></ListItemText>

        {dashboardList1 &&
          dashboardList1.map((item, index) => (
            <ListItem key={item.title} disablePadding>
              <ListItemButton onClick={() => navigate("/dashboard")}>
                <ListItemIcon
                  sx={{ minWidth: "24px", mr: "10px", color: "#1A1824" }}
                >
                  {/* <img width="100%" src={item.icon} alt="" /> */}
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.title} sx={{ color: "#1A1824" }} />
                {item.arrow}
              </ListItemButton>
            </ListItem>
          ))}

        <ListItem
          disablePadding
          sx={{
            backgroundColor: "#F0FAF9",
            borderRadius: "4px",
            height: "94px",
            pt: "10px",
          }}
        >
          <ListItemButton>
            <ListItemText>
              <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                Get 10% off your order
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "400", color: "#20615C" }}
              >
                Can only be used for today
              </Typography>
            </ListItemText>
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItemText
          primary={"General"}
          sx={{ color: "#9EA3AE", pb: "20px", mt: "8px" }}
        ></ListItemText>

        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/GetHelp")}>
            <ListItemIcon>
              <HelpOutlineOutlinedIcon sx={{ fill: "#1A1824" }} />
            </ListItemIcon>
            <ListItemText primary={"Help"} />
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <WorkspacePremiumOutlinedIcon sx={{ fill: "#E75C62" }} />
            </ListItemIcon>
            <ListItemText primary={"Logout"} sx={{ color: "#E75C62" }} />
            <ArrowForwardIosOutlinedIcon sx={{ fill: "#E75C62" }} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );



  return (
    <React.Fragment>
      <AppBar
        sx={{
          borderBottom: "1px solid #E1E1E6",
          // background: "transparent", color: "#000000" ,
          boxShadow: "none",
          backgroundColor: navColor,
          paddingLeft: { lg: "72px", md: "72px", sm: "20px", xs: "20px" },
          // paddingTop: "32px"
          // height: navSize
          position: "sticky"
        }}
      >
        <Toolbar>
          {/* <AddBusinessRoundedIcon sx={{ transform: "scale(2)" }} /> */}
          <Box
            sx={{
              width: {
                lg: "199.90px",
                md: "199.91px",
                sm: "180px",
                xs: "130px",
              },
              height: { lg: "32px", md: "32px", sm: "28px", xs: "22px" },
            }}
          >
            <Link to="/">
              <img src="./images/eatcoast.svg" alt="" width="100%" />
            </Link>
          </Box>
          {isMatch ? (
            <>
              <DrawerComp />
            </>
          ) : (
            <>
              <Tabs
                sx={{ marginLeft: "82px", color: "#9EA3AE" }}
                indicatorColor="#000000"
                textColor="inherit"
                value={value}
                onChange={(e, value) => setValue(value)}
              >
                <Tab
                  onClick={() => navigate("/")}
                  label="Home"
                  sx={{ textTransform: "capitalize" }}
                />

                {/* <Box> */}
                <Tab
                  // id="fade-button"
                  indicatorColor="secondary"
                  aria-controls={open ? "fade-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  label="Services"
                  sx={{ color: "#9EA3AE", textTransform: "capitalize" }}
                  icon={<ArrowDropDownIcon />}
                  iconPosition="end"
                />
                <Tab
                  label="About"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => navigate("/about")}
                />
                <Tab
                  label="Blog"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => navigate("/Blog")}
                />

                <Menu
                  id="fade-menu"
                  MenuListProps={{
                    "aria-labelledby": "fade-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                  sx={{ fontSize: "16px", fontWeight: "400" }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <MenuItem onClick={handleClose}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/tag-user.svg" width="100%" alt="" />
                    </Box>{" "}
                    Personal Subscription
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/bubble.svg" width="100%" alt="" />
                    </Box>
                    Multiple Subscription
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/building.svg" width="100%" alt="" />
                    </Box>
                    Business Subscription
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/weight.svg" width="100%" alt="" />
                    </Box>
                    Fitness Subscription
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/cake.svg" width="100%" alt="" />
                    </Box>
                    Event Catering
                  </MenuItem>
                </Menu>
                {/* </Box> */}
              </Tabs>

              {userFullName !== null && userFullName !== "" && userFullName !== undefined ? (
                // console.log("userFullName", userFullName),
                <Box
                  sx={{
                    width: { xl: "60%", lg: "50%", md: "30%" },
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    onClick={toggleDrawer("right", true)}
                    size="small"
                    sx={{
                      marginLeft: {
                        xl: "8px",
                        lg: "8px",
                        md: "8px",
                        sm: "8px",
                        xs: "4px",
                      },
                      borderRadius: "6px",
                      fontSize: {
                        lg: "16px",
                        md: "12px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                      height: {
                        lg: "45px",
                        md: "45px",
                        sm: "30px",
                        xs: "22px",
                      },
                      width: { lg: "30px", md: "30px", sm: "30px", xs: "22px" },
                      backgroundColor: "#D5E6E5",
                      border: "none",
                      boxShadow: "0px 0px 0px",
                      // border: "1px solid red"
                      // width: "97px",
                    }}
                    variant="contained"
                  >
                    <img src={memoji} />
                  </Button>
                  <Drawer
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                  >
                    {list("right")}
                  </Drawer>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: { xl: "60%", lg: "40%", md: "30%" },
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    sx={{
                      marginLeft: "auto",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                    }}
                    variant="outlined"
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </Button>
                  <Button
                    sx={{
                      marginLeft: "10px",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                    }}
                    onClick={() => navigate("/register")}
                    variant="contained"
                  >
                    Sign Up
                  </Button>
                </Box>
              )}
            </>
          )}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default Header;
